import React, { useState, useEffect } from "react";
import "../../../../assets/scss/home.scss";
import "../../../../assets/scss/tests.scss";
import "flatpickr/dist/flatpickr.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import x_mark from "../../../../assets/images/courses/group.svg";
import PaginatedItems from "../../../../components/tables/paginationResult";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const ResultFreeTest = (props) => {
    const location = useLocation();
    const testType = location.state?.testType;
    let array = location.state?.array;
    let testId = location.state?.testId;
    let note_id = location.state?.note_id;
    let noteData = location.state?.noteData;
    let canDoIt = location.state?.canDoIt;
    let scoreResult = location.state?.score;
    let testData = location.state?.testData;
    const role = useSelector((state) => state.layout.role);

    const history = useHistory();

    function checkTypeTest(count) {
        if (testType.length > 1) {
            return `Multiple Choice - ${count} Questions`;
        } else {
            return `${testType[0]} - ${count} Questions`;
        }
    }
    function retunedScore() {
        let countRightAnswer = 0;
        for (let i = 0; i < array.length; i++) {
            for (let j = 0; j < array[i].answers.length; j++) {
                if (
                    array[i].answers[j].correct == true &&
                    array[i].answers[j].correct ==
                        array[i].answers[j].isSelected
                ) {
                    countRightAnswer = countRightAnswer + 1;
                }
            }
        }

        return countRightAnswer;
    }
    function score() {
        let countRightAnswer = retunedScore();

        return `Your Score: ${
            countRightAnswer +
            "/" +
            array.length +
            " (" +
            Math.floor((100 * countRightAnswer) / array.length) +
            "%)"
        }`;
    }
    const redoTest = async () => {
        history.push({
            pathname: "/freeTest",
            state: {
                array,
                note_id,
                testType,
                testData,
                noteData,
                canDoIt,
            },
        });
    };

    return (
        <div>
            <div className="mt-4 resultCard">
                <div>
                    <div className="resultHeader">
                        <h1>Results</h1>

                        <img
                            src={x_mark}
                            alt="x_mark"
                            onClick={() => {
                                history.push({
                                    pathname: "/tryforfree",
                                });
                            }}
                        />
                    </div>
                </div>

                <div className="accountingHeaderContentresulttest mt-3">
                    <h1>{testData?.test_name}</h1>
                </div>
                <div className="testType">
                    <div>
                        <span>{checkTypeTest(array.length)}</span>
                    </div>
                </div>
                <div className="accountingHeaderContentresulttest">
                    <h1>{score()}</h1>
                </div>
                <div className="buttonsDivResult">
                    <button
                        className="finish"
                        onClick={() => {
                            history.push({
                                pathname: "/tryforfree",
                            });
                        }}
                    >
                        Finish
                    </button>
                    <button
                        onClick={() => {
                            redoTest();
                        }}
                    >
                        Re-take
                    </button>
                </div>

                <div className="pgItems">
                    <PaginatedItems
                        itemsPerPage={4}
                        items={array}
                        role={role}
                        testId={testId}
                        scoreResult={scoreResult}
                        isCreate={false}
                    />
                </div>
            </div>
        </div>
    );
};

export default ResultFreeTest;
